module.exports = __webpack_public_path__ + "img/cart.15ee64e9.png";